<template>
  <div class="app-container">
    <navigation title="修改密码"></navigation>
    <div class="content">
      <van-form @submit="onSubmit">
        <van-field v-model="oldPassword" name="old" type="password" label="旧密码" placeholder="请输入您的密码" center/>
        <van-field v-model="newPassword" name="new" type="password" label="新密码" placeholder="请输入新密码" center/>
        <van-field v-model="confirmPassword" name="confirm" type="password" label="确认密码" placeholder="再次输入新密码" center/>
        <div>
          <van-button class="updateSave" round block type="info" native-type="submit">保存</van-button>
        </div>
      </van-form>
    </div>
    <version></version>
  </div>
</template>

<script>
import Vue from 'vue'
import navigation from '../../components/navigation'
import {Tabbar, TabbarItem, NavBar, Cell, CellGroup, Toast} from 'vant'
import {request} from '../../untils/request'
import version from '../../components/version'

Vue.use(Tabbar).use(TabbarItem).use(NavBar).use(Cell).use(CellGroup).use(Toast)

export default {
  name: 'updatePassword',
  components: {navigation, version},
  data () {
    return {
      oldPassword: '',
      newPassword: '',
      confirmPassword: ''
    }
  },
  created () {
    window.scroll(0, 0)
  },
  methods: {
    onSubmit(values) {
      console.log('submit', values)
      if (this.oldPassword == this.newPassword) {
        Toast.fail('不能与原密码相同')
        this.oldPassword = ""
        this.newPassword = ""
        this.confirmPassword = ""
        return false
      }
      if (this.newPassword != this.confirmPassword) {
        Toast.fail('与新密码不同');
        this.newPassword = ""
        this.confirmPassword = ""
        return false
      }
      let params = {
        uid: this.$store.state.uid,
        password: this.oldPassword,
        newpassword: this.newPassword,
      }
      request('post', '/nlc-api/api/nlc/updatePassword',params).then(res => {
        console.log('修改密码结果', res)
        if (res.code === '200') {
          Toast.success('修改成功')
        } else {
          Toast.fail('修改失败');
        }
      })
    }
  }
}
</script>

<style scoped>
.app-container{
  background:#ecf5fd;
  overflow-y:scroll;
}
.content{
  width:6.94rem;
  margin:1.08rem .28rem 0 .28rem;
  border-radius:8px;
  background:#fff;
  height:12rem;
}
>>>.van-cell{
  border-radius:8px;
  height:1rem;
}
.updateSave{
  width: 6.23rem;
  height: .88rem;
  border-radius: 60px;
  color:#fff;
  font-size: .36rem;
  font-family: SourceHanSerifCN-Bold;
  margin:1.89rem 0 1.89rem .36rem;
  border:none;
}
.van-cell::after{
  border-bottom: 1px solid #B3BBC3;
}
</style>



// WEBPACK FOOTER //
// src/view/updatePassword/index.vue